import './pageTransition.css';
import { motion } from "framer-motion";
import { useNavigation } from "./navigationContext";
import { useEffect } from "react";

const variants = {
    enter: (direction) => ({
        x: direction > 0 ? 300 : -300,
        opacity: 0
    }),

    center: {
        x: 0,
        opacity: 1
    },

    exit: (direction) => ({
        x: direction > 0 ? -300 : 300,
        opacity: 0
    })
};

const PageTransition = ({ children }) => {

    const { direction } = useNavigation();

    return (
        <motion.div
            className="page-transition"
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{
                duration: 0.15,
                ease: "easeInOut"
            }}
        >
            {children}
        </motion.div>
    );
};

export default PageTransition;
